import type { ModelConfig, Slicer } from '@swf/core/store';
import type { ChestInventoryState } from '@swf/core/types/ChestInventory';

interface ChestInventoryModel extends ModelConfig<ChestInventoryState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const reducers = {
  set: (state: ChestInventoryState, payload: ChestInventoryState) => ({ ...state, ...payload })
};

const selectors = (slice: Slicer<ChestInventoryState>) => ({
  get() {
    return slice((state) => state || {});
  },
  hideChests() {
    return slice((state) => !!state.hideChests);
  }
});

const model: ChestInventoryModel = {
  state: {},
  reducers,
  selectors
};

export default model;
